export const SLIDER_DISABLE_TIMEOUT = 2000;